<div class="detail-wrap"
     [style.height]="height + 'px'"
     *ngIf="word">

  <div class="detail-head-box">

    <div class="layout-box"
         *ngIf="word.partOfSpeech?.length > 0 || word.hanjaHun?.length > 0">

      <div class="key-box">
        <div class="key-txt"
             *ngFor="let poomsa of word.partOfSpeech">{{ GetPoomsaTxt(poomsa) }}</div>
      </div>

      <div class="item-box">

        <div class="item-list">
          <div class="word-item"
               *ngFor="let hun of word.hanjaHun">
            <div class="item-txt">{{ hunBody(hun) }}
              <div class="char">{{ hunChar(hun) }}</div>
            </div>
          </div>
        </div>

      </div>

    </div>


    <div class="detail-menu">
      <div class="menu-wrap">
        <a class="detail-menu-btn bookmark-btn {{ getBmCss(word) }}"
           (click)="ToggleBookmark($event, word)"></a>
        <a class="detail-menu-btn close-btn"
           (click)="onClose()"></a>
      </div>
    </div>

  </div>

  <div class="detail-body">

    <div class="detail-item-list">

      <ng-container *ngFor="let mean of word.meaning3; let midx = index">

        <div class="detail-item-box"
             *ngIf="word.GetMeaning3Nth(midx)">

        <div class="word-list">
          <div class="word-box">

            <div class="subject">뜻{{ midx > 0 ? midx : '' }}</div>
            <div class="con">
              <app-link-content class="txt-box"
                                [content]="mean | resize"></app-link-content>
              <div class="other-list">
                <div class="other-box" *ngIf="word.GetExample3Nth(midx)">
                  <div class="other-type-box">
                    <button type="button"
                            class="other-type"
                            [class.on]="showExampleLongVowels"
                            [attr.aria-pressed]="showExampleLongVowels"
                            [attr.aria-label]="showExampleLongVowels ? '예문 장음 기호 숨기기' : '예문 장음 기호 보기'"
                            (click)="ToggleExampleLongVowels($event)">예</button>
                  </div>
                  <div class="other-txt-box">
                    <div *ngFor="let ex of word.GetExample3Nth(midx); let exidx = index"
                         class="other-txt-item" >
                      <app-link-content class="other-txt"
                                        [content]="showExampleLongVowels ? (ex | resize) : (ex | rmLongVowel | resize)"></app-link-content>
                      <div class="record-box">
                        <app-word-ex-play-btn *ngIf="word.GetExVoice(midx, exidx)"
                                              [word]="word"
                                              [exNum]="word.GetExVoiceIdx(midx, exidx)">
                        </app-word-ex-play-btn>
                        <app-word-example-btn *ngIf="word.GetExampleSjNth2(midx, exidx)?.seungjo"
                                              [word]="word"
                                              [exampleSJ]="word.GetExampleSjNth2(midx, exidx)">
                        </app-word-example-btn>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- div class="other-box" *ngIf="word.proverbs && word.proverbs.length > 0">
                  <div class="other-type-box">
                    <div class="other-type">속</div>
                  </div>
                  <div class="other-txt">{{ word.proverbs[0].proverb2}}
                    <a class="more-btn" (click)="onMoreProverb(word)">더 보기</a>
                  </div>
                </div -->

              </div>

            </div>
          </div>

        </div>

      </div>
      </ng-container>

      <div class="detail-item-box"
           *ngIf="word.examples && word.examples.length > 0">
        <div class="word-list">
          <div class="word-box">
            <div class="subject linked-example-subject-toggle"
                 role="button"
                 tabindex="0"
                 [attr.aria-pressed]="showExampleLongVowels"
                 [attr.aria-label]="showExampleLongVowels ? '예문 장음 기호 숨기기' : '예문 장음 기호 보기'"
                 (click)="ToggleExampleLongVowels($event)"
                 (keydown.enter)="ToggleExampleLongVowels($event)"
                 (keydown.space)="ToggleExampleLongVowels($event)">예문</div>
            <div class="con">
              <div class="linked-example-list">
                <app-link-example class="linked-example-item"
                                  *ngFor="let example of word.examples"
                                  [showLongVowels]="showExampleLongVowels"
                                  [example]="example"></app-link-example>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-item-box"
           *ngIf="word.synonym && word.synonym.length > 0">
        <div class="word-list">
          <div class="word-box">
            <div class="subject">유의어</div>
            <div class="con">
              <app-link-content *ngFor="let synonym of word.synonym"
                                class="txt-box gray"
                                [content]="synonym | resize"></app-link-content>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-item-box"
           *ngIf="word.derivative && word.derivative.length > 0">
        <div class="word-list">
          <div class="word-box">
            <div class="subject">관련어</div>
            <div class="con">
              <app-link-content *ngFor="let derivative of word.derivative"
                                class="txt-box gray"
                                [content]="derivative | resize"></app-link-content>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-item-box"
           *ngIf="word.homonyms && word.homonyms.length > 0">
        <div class="word-list">
          <div class="word-box type-full">
            <div class="subject">같은 글자, 다른 소리</div>
            <div class="con">

              <div class="item-list">
                <ul>
                  <li app-word-disp-list-item
                      *ngFor="let homo of word.homonyms"
                      #listHomonym
                      [word]="homo"
                      [openPopup]="true"
                      [ngClass]="{'full': classFull}">
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>


      <div class="detail-item-box"
           *ngIf="word.dialects && word.dialects.length > 0">
        <div class="word-list">
          <div class="word-box type-full">
            <div class="other-region-box">
              <div class="head-box">

                <div class="head-txt">다른 지역의 같은 말</div>

                <a class="map-btn" (click)="onOpenMap(word)">
                  <i class="ic ic-map"></i>
                  <div class="txt">지도 보기</div>
                </a>
              </div>

              <div class="body-box">
                <div class="other-region-list">

                  <app-word-detail-dialect class="other-box"
                                           *ngFor="let other of word.dialects"
                                           [dialect]="other">
                  </app-word-detail-dialect>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
